import React, { useMemo } from 'react';
import {
  sheetConfirmSummaryLinesForDisplay,
  type SheetConfirmSummaryUi,
} from '../../../services/materialCommerceSheetService.ts';
import formStyles from '../../OnboardingV2/ConversationalOnboarding/CommerceOnboarding/CommerceForm.module.scss';
import styles from '../CommerceSheetReviewStep.module.scss';
import { profileMaterialsHint } from './commerceSheetReviewConstants.ts';

export interface CommerceSheetReviewPublishedSuccessProps {
  savedSummary: SheetConfirmSummaryUi;
  successContinueLabel: string;
  onSuccessContinue: () => void;
}

export const CommerceSheetReviewPublishedSuccess: React.FC<CommerceSheetReviewPublishedSuccessProps> = ({
  savedSummary,
  successContinueLabel,
  onSuccessContinue,
}) => {
  const successLines = useMemo(
    () => sheetConfirmSummaryLinesForDisplay(savedSummary.lines),
    [savedSummary]
  );

  return (
    <div className={styles.wrap}>
      <h2 className={`${styles.title} ${styles.titlePublished}`}>Listado publicado</h2>
      <div className={styles.successPanel} role="status">
        <p className={styles.successHeadline}>{savedSummary.headline}</p>
        {savedSummary.failedNote ? <p className={styles.successFailed}>{savedSummary.failedNote}</p> : null}
        {successLines.shown.length > 0 ? (
          <ul className={styles.successList}>
            {successLines.shown.map((line, idx) => (
              <li key={idx} className={styles.successListItem}>
                {line}
              </li>
            ))}
          </ul>
        ) : null}
        {successLines.rest > 0 ? (
          <p className={styles.successOverflow}>…y {successLines.rest} producto(s) más en el listado.</p>
        ) : null}
        <p className={styles.successFooter}>{profileMaterialsHint}</p>
      </div>
      <div className={styles.actions}>
        <button type="button" className={formStyles.submit} onClick={() => onSuccessContinue()}>
          {successContinueLabel}
        </button>
      </div>
    </div>
  );
};
